import { Controller } from 'react-hook-form'
import { civilities } from '../userFormData'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { useUserFormContext } from '../utils/userFormContext'

const Civility = () => {
    const { state } = useUserFormContext()
    const { control } = useFormContextUser()

    const getCivility = (raw: string | undefined) =>
        raw ? civilities.find((option) => option.value.toLowerCase() === raw.toLowerCase()) : undefined

    return (
        <Controller
            control={control}
            name="civility"
            rules={{
                required: 'Cette information est obligatoire et n’a pas été renseignée',
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="select"
                    name={field.name}
                    label="Civilité"
                    type="default"
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    required
                    locked={state.rppsLocked}
                    readonly={state.rppsLocked}
                    disabled={state.rppsLocked}
                    placeholder="Civilité"
                    value={field.value || undefined}
                    renderLabel={() => (field?.value ? getCivility(field?.value)?.label : undefined)}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    options={civilities}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Civility
